import React, { useEffect, useRef } from "react";
import Stars from "./Stars";
const SingleReview = (props) => {
  const loaded = useRef(false);
  let start = props.page * 10 - 9;
  let end = props.page * 10 + 1;
  if (props.page === 1) {
    start = 0;
    end = 10;
  }

  // useEffect(() => {
  //   if (loaded.current) {
  //     document
  //       .getElementById("lrmReviews")
  //       .scrollIntoView({ behavior: "smooth" });
  //   } else {
  //     loaded.current = true;
  //   }
  // }, []);

  //console.log("start: " + start + " end: " + end);
  return props.reviewData.slice(start, end).map((review) => {
    return (
      <>
        <div
          id={review.reviewId}
          key={review.reviewId}
          className="lrm-reviews-single-review"
        >
          <div className="flex">
            <Stars starCount={review.rating} />
            <p className="lrm-reviews-source">
              On {review.sourceType}, {review.reviewDate}
            </p>
          </div>
          <p className="lrm-reviews-name">
            <b>
              {review.reviewer.firstName} {review.reviewer.lastName}
            </b>
          </p>
          <p>{review.comments}</p>
          {review.response && (
            <p>
              <b>Business Response:</b>
              <br />
              {review.response}
            </p>
          )}
        </div>
      </>
    );
  });
};

export default SingleReview;
